import { DakeListWxAccountsReq, DakeListWxAccountsRsp, DakeUpdateWxAccountSwitchesReq } from "@/data-contracts";
import request, { _GET, _POST } from "@/services/request";

/**
 * 列举微信账号
 * GET /admin/wxAccounts
 */
export const listWxAccounts = (params?: DakeListWxAccountsReq) =>
  request<DakeListWxAccountsRsp, DakeListWxAccountsReq>(_GET, "/admin/wxAccounts")(params || {});

/**
 * 更新微信账号调试开关
 * POST /admin/wxAccount/updateSwitches
 */
export const updateWxAccountSwitches = (params: DakeUpdateWxAccountSwitchesReq) =>
  request<null, DakeUpdateWxAccountSwitchesReq>(_POST, "/admin/wxAccount/updateSwitches")(params);

const wxAccountApis = {
  listWxAccounts,
  updateWxAccountSwitches,
};

export default wxAccountApis;
